import React from 'react';
import { toDateTime } from '../../../helpers/Format';
import { Texto } from '../Texto';
export const BlockDate = ({ fecha, align, fontSize, bold }) => (React.createElement(Texto, { texto: toDateTime(fecha), align: align, fontSize: fontSize, bold: bold }));



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Blocks/BlockDate.tsx
// module id = 509
// module chunks = 0